<template>
  <div id="logging-in">
    <div class="container-fluid" style="padding: 20px 0px; margin-top:20px;">
      <!--  -->
      <div class="row text-center" style="margin: 20px 0 20px">
        <div class="col">
          <H1 style="color: var(--theme-primary);">Signing in ...</H1>
        </div>
      </div>
      <!--  -->
      <!-- Loading spinner -->
      <spinner :spinnerOn="true"></spinner>
    </div>
  </div>
</template>
<script>
import Spinner from '@/components/Spinner'
import NoTopNavFooter from "@/components/widgets/NoTopNavFooter"
import store from '@/store'
const apiUrl = process.env.API_URL;
import storage from '@/helpers/storage';
import jwtDecode from 'jwt-decode'
import okta from '@/helpers/okta'
import idmApi from '@/idm-api'
import { locale } from '@/i18n/locale.js'
import { EventBus } from '@/event-bus.js';
const onecargilladmingroupid = process.env.ONECARGILL_ADMIN_GROUP_ID;
// import store from '@/store'
// import authApi from '@/helpers/auth-api'
export default {
  name: 'logging-in',
  components: {
    Spinner,
    NoTopNavFooter
  },
  created() {
    // var authUserEmail = store.state.user.email;
    // authApi.getUserAuthorization(authUserEmail).then(response => {
      // var dataObj = JSON.parse(response.data);
      // var termsAndConditions = dataObj[0].tandc;
    var self = this
    console.log('dev app--------------------------')
    var appname = storage.get('samlapp')
    if (appname !== '') {
      idmApi.getGroupsByUserId(`${apiUrl}/auth/apps/${appname}/search`).then(function (response) {
        // console.log((response.data))
        console.log('redirect to :' + (response.data)[0]._links.appLinks[0].href)
        window.open((response.data)[0]._links.appLinks[0].href, '_self')
      }).catch(err => {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
        if (window.location.hash.split('&')[1].split('=')[0] === 'error') {
          storage.clearAll();
          okta.oktaSignOut(window.location.hash.split('&')[1].split('=')[1]);
        }
      })
    } else {
      setTimeout(() => {
        // if (termsAndConditions === 'Y') {
        self.loading = true
        var idt = ''
        var userId = ''
        if (window.location.hash !== undefined && window.location.hash !== '') {
          if (window.location.hash.split('&')[1].split('=')[0] === 'error') {
            storage.clearAll();
            okta.oktaSignOut(window.location.hash.split('&')[1].split('=')[1]);
          }
          idt = window.location.hash.split('&')[0].split('=')[1]
          var jwt = jwtDecode(idt);
          if (window.location.hash.split('&')[0].split('=')[0].indexOf('access_token') > -1) {
            storage.set('access_token', window.location.hash.split('&')[0].split('=')[1])
            userId = jwt.uid
          } else {
            userId = jwt.sub
          }
          storage.set('cf-user', {'sub': userId})
          console.log("userIduserId" + JSON.stringify(jwtDecode(idt)))
        } else {
          if (storage.get('okta-token-storage')) {
            userId = storage.get('okta-token-storage').accessToken.claims.uid
            var accessToken = storage.get('okta-token-storage').accessToken.accessToken
            storage.set('access_token', accessToken)
            storage.set('cf-user', {'sub': userId})
            userId = storage.get('cf-user').sub
          } else {
            self.$router.push({ path: '/Login' })
          }
        }
        // if (jwt !== undefined && jwt != null) { //eslint-disable-line
        this.setUserLocale(userId)
        // }
        var adminGroupsArr = []
        var adminAppsArr = []
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupList`).then(function (response) {
          adminGroupsArr = response.data.map(function(i) {
            // console.log(i.groupId)
            return i.groupId
          })
          adminAppsArr = response.data.map(function(i) {
            return i.applicationId
          })
          storage.set('adminConfigMaster', JSON.stringify(response.data))
          storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
          storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
          idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${userId}/groups`).then(function (response) {
            storage.set('grpsOfUser', JSON.stringify(response.data))
            storage.set('isServiceAccountGroupMember',
            response.data.filter(x => x.profile.name.toLowerCase().indexOf('service accounts') > -1).length > 0 ? true : false) // eslint-disable-line
            var isSuperAdmin = false
            var isAdmin = false
            // console.log(adminGroupsArr)
            var adminToArr = []
            adminToArr = response.data.filter(function(i) {
              if (adminGroupsArr.indexOf(i.id) > -1) {
                return i
              }
            })
            for (var w = 0; w < response.data.length; w++) {
              if (response.data[w].id === onecargilladmingroupid) {
                isSuperAdmin = true
              }
            }
            if (adminToArr.length > 0) {
              isAdmin = true
            }
            if (isSuperAdmin) {
              store.commit('setUserRole', 'superadmin')
              self.$router.push({ name: 'Admin' });
            } else if (isAdmin) {
              store.commit('setUserRole', 'admin')
              self.$router.push({ name: 'Admin' });
            } else {
              store.commit('setUserRole', 'notadmin')
              self.$router.push({ name: 'MyProfile' });
            }
          }).catch(err => {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          })
        }).catch(err => {
          console.log(err)
        })
        // } else {
          //  this.$router.push({ name: 'TandC' });
        // }
      }, 1000);
    }
    // }).catch(err => {
    // });
  },
  methods: {
    setUserLocale (loginId) {
      var self = this
      self.loading = true
      idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${loginId}`).then(function (response) {
        self.loading = false
        storage.set('idprovider', response.data.credentials.provider.type.toLowerCase())
        var profileLang = response.data.profile.locale
        console.log("profileLang" + profileLang)
        if (profileLang !== undefined) {
          if (profileLang !== null && profileLang.trim() !== '') {
            Object.keys(locale.lang_obj).forEach(function(i) {
              if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                locale.lang = i
                EventBus.$emit('lang', i)
              }
            })
          } else {
            locale.lang = 'en_US'
            EventBus.$emit('lang', 'en_US')
          }
          storage.set('user-lang', locale.lang)
          /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/auth/${locale.lang}/securityquestions`).then(function (response) {
            storage.set('listofsecquestions', response.data)
          }) */
        } else {
          locale.lang = 'en_US'
          storage.set('user-lang', 'en_US')
          EventBus.$emit('lang', 'en_US')
          /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/auth/${locale.lang}/securityquestions`).then(function (response) {
            storage.set('listofsecquestions', response.data)
          }) */
        }
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// LoggingIn.vue?19655d15